import { createStyles, Theme } from '@material-ui/core/styles';

import { colors } from '@shared/theme/colours';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    label: {
      color: colors.black.darker,
      fontSize: 15,
      fontWeight: 400,
      marginBottom: spacing(0.5),
    },
    labelText: {
      color: colors.black.darker,
      fontSize: 14,
      fontWeight: 400,
    },

    selectInput: {
      width: 70,
    },
    selectFloorContainer: {
      flex: 1,
    },

    checkBox: {
      marginRight: 0,
    },
    textCheckbox: {
      fontSize: 14,
      color: colors.black.darkest,
      display: 'flex',
      alignItems: 'center',
      marginBottom: spacing(2),
    },
    floorCheckbox: {
      marginRight: 0,
    },
    description: {
      width: 160,
    },
    wrap: {
      borderTop: `1px solid ${colors.grey.light}`,
      padding: spacing(4, 0),
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: spacing(4),
      flexWrap: 'nowrap',
    },
    includeCheckbox: {
      marginRight: 0,
    },
    spaceName: {
      color: colors.kato.neutral[900],
      fontSize: 14,
      fontWeight: 500,
      display: 'flex',
      flex: 1,
      gap: spacing(0.5),
      userSelect: 'none',
    },
    sizeWrapper: {
      gap: spacing(4),
    },
    metricSelect: {},
    sizeField: {
      width: 120,
    },
    propertyTypeSelect: {
      width: 118,
    },
    propertyTypeSelectTooltip: {
      width: 'unset',
    },
  });
